// extracted by mini-css-extract-plugin
export default {"gameInfo":"GameInfo_gameInfo__BPGlr","icon":"GameInfo_icon__JxfR4"};